<template>
  <div id='ae' class='' v-loading='loading'>

    <el-dialog class='gDia' v-loading='loading' :title="'FTP' + $t('app_addconfig')" v-model="isAddFile" size=''>

      <!-- <el-row><el-col :span='10'><div style='width:100%;background:none;text-align:left;'>
        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        @keyup.enter.native='srchDevice'
        style=''
        v-model="srchValue">
        </el-input>
      </div></el-col></el-row> -->
      
      <el-table
      :data="fdatas"
      border
      class=''
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align='center'
          prop="fileName"
          :label="$t('app_filename')"
          width="150">
        </el-table-column>
        <el-table-column
          align='center'
          prop="size"
          :formatter="setSize"
          :label="$t('app_fileSize')"
          width="120">
        </el-table-column>
       
        <el-table-column
          align='center'
          prop="addTime"
          :label="$t('app_addtime')"
          width='176'>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='100'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='pushInstall(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_add')" placement="top">
              <el-button type='text'  @click='addFile(scope.row)'><i class="fa fa-plus" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- <div class="gPgDiv" style=''>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div> -->
    </el-dialog>

    <div v-show="config.data ? config.data.status === '3' : false">
      <el-alert
        style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;'
        :title="reason"
        type="error"
        show-icon>
      </el-alert>
    </div>

    <el-dialog class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
      <div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

        <span>

          <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="channelId" clearable :placeholder="$t('app_distributor')">
            <el-option
              v-for="item in channels"
              :key="item.mechanismid"
              :label="item.mechanismname"
              :value="item.mechanismid">
            </el-option>
          </el-select>
        </span>

        <span>

          <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="status" clearable :placeholder="$t('app_status')">
            <el-option
              v-for="item in stModel"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select>
        </span>


        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        @keyup.enter.native='srchDevice'
        style='width:40%;margin-bottom:10px;'
        v-model="srchValue">
        </el-input>
      </div>




      <el-table
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_terNo')"
          width="150">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column>
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>

        <el-pagination
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        class='gPg'
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

      </div>

    </el-dialog>

    <el-dialog title="" v-model="showPic.value" size='small'>
      <img :src='showPic.data' style='width:300px;'>
    </el-dialog>

    <div v-show="isShowReason">
      <el-alert
        style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;'
        :title="reason"
        type="error"
        show-icon>
      </el-alert>
    </div>

    <div class='gPageBorder'>


      <el-form  class='gForm' ref="form"  :model='form' :rules='rules'  label-position="right"   label-width="12.5%" style=''>

        <el-form-item :label="$t('app_filename')" prop='name'>
          <el-input  style='' class='aeMg' v-model='form.name'></el-input>
        </el-form-item>

        <el-form-item :label="$t('app_filedesc')" prop=''>


          <el-input
          v-show='isShowCommon(1)'
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 9999}"
          v-model='form.memo'
          style='float:left;'
          class='aeMg'
          >
          </el-input>

          
            <!-- <textarea v-show='isShowCommon()' v-model='form.launcherDesc' type='file' style='width:40%;height:80px;border:1px solid #8492A6;font-size:13px;line-height:1.3' class='aeMg'></textarea> -->
        </el-form-item>


       <!--180px <el-form-item v-show='isShowUpdateDesc' :label="$t('app_udState')" prop='appTypeValue' style=''>

            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 99999}"
              v-model='updateDescContent'
              style='width:100%;float:left;'
              class='aeMg'
              >
             </el-input>
        </el-form-item> -->

        


        <el-form-item :label="$t('app_ulfile')" v-show="true" :prop='ulprop'>

          <el-radio class="radio" v-model="ulType" label='0'>
            {{$t('app_lcupload')}}
          </el-radio>
          <el-radio :disabled="form.flag != 'ZT_CARDBLACK'" class="radio" v-model="ulType" label="1">
            {{$t('app_addofcloud')}}
          </el-radio>

          <el-upload
            v-if="ulType == 0"
            class="upload-demo"
            name='fileUpload'
            :action="fileUploadUrl"
            :before-upload="fileBeforeUpload"
            :on-success="fileUploadSuccess"
            multiple
            :file-list="fileList">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <div slot="tip" class="el-upload__tip">{{$t('app_limitxml')}}</div>
          </el-upload>
          <span v-else>
            <br/>
            <el-button @click='isAddFile = true' size='small'  type='primary'>{{$t('app_addfile')}}</el-button>
            <label style="margin-left:10px;">{{form.fname}}</label>
          </span> 

        </el-form-item>

        <el-form-item style="color:red;" v-show='isLowerTip'>
          {{$t('app_udxmllowertip')}}
        </el-form-item>


        <el-form-item  :label="$t('app_ID')" prop='flag'>
          <!-- <el-input  :disabled="isTag"  style='' class='aeMg' v-model='form.flag'></el-input> -->
          <el-select :disabled="isTag"  style='margin-right:10px;' v-model="form.flag" clearable :placeholder="$t('app_select')">
            <el-option
              v-for="item in flags"
              :key="item.vl"
              :label="item.lb"
              :value="item.vl">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item :label="$t('app_version')" prop='ver'>
          <el-input-number :disabled="isVer"  style="width:40%;" v-model="form.ver" :min="1"  label="描述文字"></el-input-number>
        </el-form-item> -->


        <!-- <el-form-item :label="$t('app_udmode')" prop=''>
          <el-radio v-model="form.updateType" label="0">{{$t('app_cover')}}</el-radio>
          <el-radio v-model="form.updateType" label="1">{{$t('app_append')}}</el-radio>
        </el-form-item> -->

        <!-- style="color:#409EFF;background:lightblue;" -->
        <!-- <el-form-item v-show='true'  :label="$t('app_excludeapp')" prop='' v-loading='loading1'>
            <el-tag
              :key="tag"
              type='primary'
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ {{$t('app_excludeapp')}}</el-button>

            <p style='font-size:12px;color:gray'>{{$t('app_excludefsttip')}}</p>
        </el-form-item> -->

        <el-form-item v-show='config.type === 3' :label="$t('app_testInstall')" style='background:none;margin-top:30px;' >
          <el-button type='primary'  class='aeMg' @click='pushInstall'>{{$t('app_pushInstall')}}</el-button>
        </el-form-item>
        <el-form-item v-show='config.type === 3' :label="$t('app_isPass')" style='background:none;'>
          <el-radio class="radio aeMg"  v-model="radio" label="1">{{$t('app_pass')}}</el-radio>
          <el-radio class="radio aeMg" v-model="radio" label="2">{{$t('app_ban')}}</el-radio>
        </el-form-item>
        <el-form-item v-show="radio === '2'" :label="$t('app_banReason')" style='background:none;'>
          <textarea v-model='checkDesc' style='width:100%;height:60px;float:left;'></textarea>
        </el-form-item>
        <el-form-item style='background:none;'  v-show='isShowCommon()'>
          <el-button class='aeMg' @click='cancel' type='' style=''>{{$t('app_cancel')}}</el-button>
          <el-button type='primary' style='' class='aeMg' @click="uploadApp('form')">{{$t('app_save')}}</el-button>
        </el-form-item>

        <!-- <el-form-item v-show='config.type === 2' label="" style='background:none;'>

          <el-button type='' @click='$router.go(-1)' style=''>{{$t('app_cancel')}}</el-button>
          <el-button type='primary' @click='lcNew' style=''>{{$t('app_upload') + 'launcher'}}</el-button>

        </el-form-item> -->

      </el-form>

      <!-- <div v-show='config.type === 2 && config.isHistory' style='border-top:1px solid #8492A6;text-align:center;'>
        <p style='text-align:left;margin-top:20px'>{{$t('app_hisVer')}} </p>
        <el-button v-show="showUploadNew"  @click='uploadNew' type='primary' style='float:right;margin-bottom:20px;'>{{$t('app_ulNew')}}</el-button>

        <el-table
          :data="tableData"
          border
          style="width: 100%;margin: 20px 0 20px 0;">
          <el-table-column
            header-align='center'
            align='center'
            prop="launcherName"
            :label="$t('app_launcherName')"
            width="">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop="appVersion"
            width=''
            :label="$t('app_version')">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop="appCategoryName"
            width=''
            :label="$t('app_type')">
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            :formatter="dateFormat"
            prop="createTime"
            width='170'
            :label="$t('app_createTime')">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop=""
            width='90'
            :label="$t('app_operate')">
            <template slot-scope='scope'>
              <el-button type=text @click='deleteAppHis(scope.row)'>{{$t('app_del')}}</el-button>
              <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2'" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div> -->


    </div>
  </div>
</template>

<style>

  .contentColor{color:#495769}
  .avatarF{height:auto;width:128px;display:block;}

  #ae{width:100%;background:none;}




  #aeScreenCut img{height:100%;width:auto;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
  #aeCpDiv{height:180px;width:120px;display:inline-block;background:none;margin-right:10px;}
  .cImg{width:100%;}

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>

<script>
  import mm from 'moment'
  export default {
    data () {
      var tagCheck = (rule, value, callback) => {
        // console.log('checkValue ', value)
        if (!value) {
          callback(new Error(this.$t('noVerTag')));
        } else {
          callback()
        }
      }
      return {
        ulinfo: {
          tip: this.$t('app_ulNormalSt')  + '，' + this.$t('app_limitxml'),
          index: 0,
          icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
        },
        mechanismId: window.localStorage['mechanismId'],
        status: '',
        isAddFile: false,
        ulType: '0',
        flags: [
          {lb: 'AID', vl: 'ZT_AID'},
          {lb: 'RID', vl: 'ZT_RID'},
          {lb: 'BLACKLIST', vl: 'ZT_CARDBLACK'}
        ],
        tipColor: {color: '#13CE66'},
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        channels: [],
        isLowerTip: false,
        updateType: false,
        channelId: '',
        rules: {
          name: [
            { required: true, message: this.$t('app_inputName'), trigger: 'blur' }
          ],
          ver: [
            { required: true,type:'number', message: this.$t('app_inputVer'), trigger: 'blur'}
          ],
          flag: [
            {required: true, message: this.$t('app_inputID'), trigger: 'blur', validator: tagCheck }
          ],
          appPackage: [
            { required: true, message: this.$t('app_inputPkg'), trigger: 'blur' }
          ],
          memo: [
            { required: true, message: this.$t('app_inputIntrol'), trigger: 'blur' }
          ],
          appTypeValue: [
            { required: true, message: this.$t('app_selectType'), trigger: 'blur' }
          ],
          url: [
            { required: true, message: this.$t('app_plsUpl'), trigger: 'blur' }
          ]/*,
          smImageUrlValue: [
            { required: true, message: this.$t('app_ulIcon'), trigger: 'blur' }
          ],
          bgImageUrlValue: [
            { required: true, message: this.$t('app_ulLarIcon'), trigger: 'blur' }
          ],
          caps: [
            { required: true, message: this.$t('app_ulScreenShot'), trigger: 'blur' }
          ]*/
        },
        form: {
          id: '',
          profilesId: '',
          name: '',
          ver: 0,
          flag: '',
          url: '',
          key: '',
          updateType: '0',
          md5: '',
          size: "",
          appPackage: '',
          memo: '',
          fname: ''
        },
        isTag: false,
        isVer: false,
        showPic: {value: 0, data: ''},
        srchValue: '',
        installTypes: [{label: this.$t('app_autoInstall'), value: 0}],
        fileSize: 0, // 上传文件大小
        tableData: [],
        fdatas: [],
        checkDesc: '',
        radio: '1',
        smImageUrl: '',
        bgImageUrl: '',
        dialogVisible: false,
        appTypes: [],
        loading: 0,
        loading1: 0,
        loadingBig: 0,
        loadingSm: 0,
        config: {},
        cp0: '',
        cp1: '',
        cp2: '',
        cp3: '',
        cp4: '',
        captures: [],
        fileList: [],
        isUpload: 0,
        index: 1,
        total: 0,

        dynamicTags: [],
        inputVisible: false,
        inputValue: '',
      }
    },
    computed: {
      ulprop () {
        if (this.ulType == 1) {
          return ''
        } else {
          return 'url'
        }
      },
      bIcon () {
        if (this.config.data) {
          return this.config.data.appBigIcon ? imgFullUrl(this.config.data.appBigIcon) : require('../../../assets/df.png')
        } else {
          return ''
        }
      },
      sIcon () {
        if (this.config.data) {
          return this.config.data.appSmallIcon ? imgFullUrl(this.config.data.appSmallIcon) : require('../../../assets/df.png')
        } else {
          return ''
        }
      },
      showUploadNew () {
        if (this.config.data) {
          if (this.config.data.isUpload === '0') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      isShowUpdateDesc () {
        if (this.config.data) {
          if (this.config.data.updatedesc) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      updateDescContent () {
        var vl = this.config.data ? this.config.data.updatedesc : ''
        // alert(this.config.data.updatedesc)
        return vl
      },
      prdes () {
        return (this.config.data)? this.config.data.launcherDesc : ''
      },
      uData () {
        return {token: 1234}
      },
      imgUploadUrl () {
        // return this.$imgUploadUrl
        return this.$urls.picUrl
      },
      fileUploadUrl () {
        //return this.$launchUlUrl
        var vl = this.$urls.xmlFileUrl + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang
        return vl
      },
      reason () {
        if (!this.config.data) {
          return ''
        }
        var rs = this.config.data.auditContent
        return rs? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason')  + ':' +  this.$t('app_noInput')
      },
      isShowReason () {
        if (this.config) {
          if (this.config.data) {
            if (this.config.data.appStatus === '3') {
              return 1
            } else {
              return 0
            }
          } else {
            return 0
          }
        } else {
          return 0
        }
      }
    },
    methods: {
      addFile (row) {
        this.form.fname = row.fileName
        this.form.size = row.size
        this.form.md5 = row.md5
        this.isAddFile = false
        // this.form.key = ''
        // this.form.url = ''
      },
      setSize (row) {
        return row.size + 'KB'
      },
      getList () {
        this.$ftpfList((res) => {
          this.fdatas = res.data?res.data:[]
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getDetail () {
        this.$getFstDetail(this.config.data.recordId, (res) => {
          if (res.status === 200) {
            this.fillEdit(res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.makeExApp()
      },

      showInput() {
        this.inputVisible = true;
        var _this = this
        this.$nextTick(_ => {
          _this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
          this.makeExApp()
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      
      lcNew () {
        // this.form.caps = this.makeCapture()
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = 1
            var form = this.form
            this.$updateLauncher(form.launcherName, form.launcherDesc, form.caps, form.appUrl, form.packageName, form.version, form.verTag, this.fileSize, this.config.data.launcherid, localStorage.mechanismId, (res) => {
              this.loading = 0
              if (res.status === 200) {
                this.$message.success(res.message)
                this.$router.go(-2)
              } else {
                this.$message.error(res.message)
              }
            }, () => {
              this.loading = 0
              this.$message(this.$t('app_rqsError'))
            })

          } else {
            return false
          }

        })
      },
      selectChange (vl) {
        this.getDevices()
      },
      getChannels () {
        this.$getChannelList(10000, 1, '','','', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      hBlur (name) {
        // this.form.caps = this.makeCapture()
        this.$refs[name].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
      showBigPic () {
        this.showPic = {value: 1, data: this.imgFullUrl(this.config.data.appBigIcon)}
      },
      showScreenShot (path) {
        this.showPic = {value: 1, data: this.imgFullUrl(path)}
      },
      pushInstall () {
        this.dialogVisible = true
      },
      makeAppPath (url) {
        var path = url
        if (!path) {
          if (this.config.data) {
            path = this.config.data.appUrl
            if (!path) {
              return ''
            }
          } else {
            return ''
          }
        }
        var arr = path.split('/')
        return arr[arr.length - 1]
      },
      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteApp1(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }

          }).catch(() => {
          })
        }
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      deleteCapture0 () {
        this.cp0 = ''
        this.cp0Value = ''
      },
      deleteCapture1 () {
        this.cp1 = ''
        this.cp1Value = ''
      },
      deleteCapture2 () {
        this.cp2 = ''
        this.cp2Value = ''
      },
      deleteCapture3 () {
        this.cp3 = ''
        this.cp3Value = ''
      },
      deleteCapture4 () {
        this.cp4 = ''
        this.cp4Value = ''
      },
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },
      close () {
        this.$router.go(-1)
      },
      isShowCommon (isShow) {
        // 新建为默认入框，编辑不显示输入框，其他
        // if (isShow && (this.config.type === 2 || this.config.type === 3)) {
        //   return 1
        // } else if (!isShow && (this.config.type !== 2 && this.config.type !== 3)) {
        //   return 1
        // } else {
        //   return 0
        // }
        return true
      },
      tipBf () {
        this.loading1 = 1
        return 1
      },
      handleSmAvatarSuccess (res, file) {
        // console.log(res)
        this.loadingSm = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.form.smImageUrlValue = res.data
          this.smImageUrl = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleBgAvatarSuccess (res, file) {
        this.loadingBig = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.form.bgImageUrlValue = res.data
          this.bgImageUrl = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleAvatarSuccessCp0 (res, file) {
        this.loading1 = 0
        // console.log(res)
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.cp0Value = res.data
          this.cp0 = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleAvatarSuccessCp1 (res, file) {
        this.loading1 = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.cp1Value = res.data
          this.cp1 = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleAvatarSuccessCp2 (res, file) {
        this.loading1 = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.cp2Value = res.data
          this.cp2 = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleAvatarSuccessCp3 (res, file) {
        this.loading1 = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.cp3Value = res.data
          this.cp3 = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      handleAvatarSuccessCp4 (res, file) {
        this.loading1 = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.cp4Value = res.data
          this.cp4 = URL.createObjectURL(file.raw)
          this.hBlur('form')
        }
      },
      beforeSmAvatarUpload (file) {
        var size = file.size / 1024
        if (size > 100) {
          this.$message.error(this.$t('app_fileOver') + '100k')
          return false
        }
        this.loadingSm = 1
        return true
      },
      beforeBgAvatarUpload (file) {
        var size = file.size / 1024
        if (size > 200) {
          this.$message.error(this.$t('app_fileOver') + '200k')
          return false
        }
        this.loadingBig = 1
        return true
      },
      handleRemove (file, fileList) {
        // console.log(file, fileList)
      },
      makeCapture () {
        var str = ''
        if (this.cp0Value) {
          str += this.cp0Value + ','
        }
        if (this.cp1Value) {
          str += this.cp1Value + ','
        }
        if (this.cp2Value) {
          str += this.cp2Value + ','
        }
        if (this.cp3Value) {
          str += this.cp3Value + ','
        }
        if (this.cp4Value) {
          str += this.cp4Value + ','
        }
        return str.substring(0, str.length - 1)
        /* arr.forEach((value, index, array) => {
          path += value.response.data + ','
        })
        return path.substring(0, path.length - 1) */
      },
      makeExApp () {
        var str = ''
        console.log('dydydy', this.dynamicTags)
        this.dynamicTags.forEach((vl) => {
          str += vl + ','
        })
        str = str.slice(0,str.length - 1)
        this.form.appPackage = str
        this.hBlur('form')
      },
      uploadApp (formName) {

      
        if (window[this.$route.path]) {
          this.$message.error(this.$t('app_appLoding'))
          return
        }
        if (this.ulType == 0) {
          this.form.fname = ''
        } else {
          // this.form.url = ''
          // this.form.key = ''
        }
        // this.form.caps = this.makeCapture()
        this.$refs[formName].validate((valid) => {
          if (valid) {

            this.loading = 1
            if (this.config.type === 1) {
              
              this.$editFst(this.form.fname, this.form.updateType, this.form.id, this.form.profilesId ,this.form.name, this.form.ver, this.form.flag, this.form.url, this.form.key, this.form.md5, this.form.size, this.form.appPackage, this.form.memo, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$message.success(res.message)
                  if (this.$route.query.setlocal) {
                    var key = 'stfileDetail'
                    var obj = this.$getWObj()[key]
                    obj.name = this.form.name
                    obj.url = this.form.url
                    obj.flag = this.form.flag
                    obj.memo = this.form.memo
                    this.$setWObj(key, obj)
                  }
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                this.loading = 0
                this.$message(this.$t('app_rqsError'))
              })


            } else if (this.config.type === 0) {

              this.addRqs('')

            } else {
              this.addRqs(this.config.data.id) //recordId
            }
          } else {
            return false
          }

        })
      },
      addRqs (id) {
        var ver
        if (this.isTag) {
          
          ver = parseInt(this.form.ver) + 1

        } else {
          ver = 0
        }
        this.$addFst(this.form.fname, this.form.updateType,id, this.form.name, ver, this.form.flag, this.form.url, this.form.key, this.form.md5, this.form.size, this.form.appPackage, this.form.memo, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message(this.$t('app_rqsError'))
        })
      },
      setTipOk (isok, msg) {
        if (isok) {
          this.ulinfo.index = 1
          this.tipColor = {color: '#13CE66'}
          this.ulinfo.tip = ''
        } else {
          this.ulinfo.index = 2
          this.tipColor = {color:'#FF4949'}
          this.ulinfo.tip = msg
        }
      },
      fileUploadSuccess (res, file) {

        //{"fileUrl":"/file/upload/config/config/MiW1525939984636.xml","size":"3010","key":"d17e718fa47f4e4a891328094e7b4b57","md5":"7e62a6224415035f6220ee656487001d","version":"001","flag":"alee88666","status":200}

        window[this.$route.path] = ''
        console.log('file', res)
        this.ulinfo.tip = res.message
        if (res.status === 200) {
          if (this.config.type == 2) {
            //res.data.flag == this.config.data.flag
            if (true) {
              this.setTipOk(true, '')
              // this.form.flag = res.data.flag
              // this.isTag = res.data.flag? true:false
              // this.form.ver = res.data.version
              // this.isVer = res.data.version? true:false
              this.form.md5 = res.data.md5
              this.form.key = res.data.key
              this.form.size = res.data.size
              this.form.url = res.data.fileUrl
              this.hBlur('form')

              if (res.data.version < this.config.data.version) {
                this.isLowerTip = true
              } else {
                this.isLowerTip = false
              }
            } else {
              this.setTipOk(false, this.$t('app_udsamexml'))
              this.isLowerTip = false
              this.form.flag = ''
              this.form.ver = ''
              this.form.md5 = ''
              this.form.key = ''
              this.form.size = ''
              this.form.url = ''
              this.hBlur('form')
            }
          } else {
            this.setTipOk(true, '')
            // this.form.flag = res.data.flag
            // this.form.ver = res.data.version
            this.form.md5 = res.data.md5
            this.form.key = res.data.key
            this.form.size = res.data.size
            this.form.url = res.data.fileUrl
            this.hBlur('form')
          }
          this.fileList = [{name: file.name}]
        } else {
          this.ulinfo.index = 2
          if (this.config.type !== 1) {
            this.fileList = []
          } else {
            this.fileList = [{name: this.makeAppPath(this.config.data.appUrl)}]
          }
          this.$message.error(res.message)
          this.tipColor = {color: '#FF4949'}
        }
      },
      fileBeforeUpload (file) {
        console.log(file)
        if (file) {
          window[this.$route.path] = 1
          var ar = file.name.split('.')
          var type = ar[ar.length - 1]
          /* if (type === 'apk') {
            var limit = 500000 // k单位
            if (file.size / 1000 > limit) {
              this.$message.error(this.$t('app_fileOver') + '500M')
              return false
            }
            window[this.$route.path] = 1
            return true
          } else {
            this.$message.error(this.$t('app_onlyApk'))
            return false
          } */
        } else {
          this.$message.error(this.$t('app_onlyApk'))
          return false
        }
      },
      setCapturesIn (strs) {
        if (strs) {
          var arr = strs.split(',')
          // console.log('ddd', arr)
          arr.forEach((value, index, array) => {
            switch (index) {
              case 0:
                this.cp0 = this.imgFullUrl(value)
                this.cp0Value = value
                break
              case 1:
                this.cp1 = this.imgFullUrl(value)
                this.cp1Value = value
                break
              case 2:
                this.cp2 = this.imgFullUrl(value)
                this.cp2Value = value
                break
              case 3:
                this.cp3 = this.imgFullUrl(value)
                this.cp3Value = value
                break
              case 4:
                this.cp4 = this.imgFullUrl(value)
                this.cp4Value = value
                break
            }
          })
        }
      },
      setCapturesArr (strs) {
        if (strs) {
          var arr = strs.split(',')
          this.captures = arr
        }
      },
      fillEdit (data) {
        // id: '',
        // profilesId
        //   name: '',
        //   ver: '',
        //   flag: '',
        //   url: '',
        //   key: '',
        //   md5: '',
        //   size: "",
        //   appPackage: '',
        //   memo: ''
        
        this.form.id = data.id
        this.form.profilesId = data.profilesId
        this.form.name = data.name
        this.form.ver = data.version
        this.form.flag = data.flag
        this.form.url = data.url
        this.form.key = data.key
        this.form.md5 = data.md5
        this.form.size = data.size
        this.form.appPackage = data.appPackage
        this.form.memo = data.memo
        this.form.updateType = data.updateType
        this.form.fname = data.ftpFileName
        // this.ulType = data.ftpFileName?'1':'0'

        var elm = data.url.split('/').pop()
        elm = elm ? elm : ''
        this.fileList = [{name: elm}]

        if (data.appPackage) {
          this.dynamicTags = data.appPackage.split(',')
        }
        

        this.ulinfo.index = 1 

        
      },
      getTypeList () {
        this.$getAppTypeList(100000000, 1, (res) => {
          if (res.status === 200) {
            console.log(res)
            this.appTypes = res.data
          } else {
            this.$message(res.message)
          }
        }, '')
      },
      cancel () {
        // cancel
        this.$router.go(-1)
      },
      verify () {
        this.loading = 1
        var id = this.config.data.applicationid
        var passValue = (this.radio === '1') ? '2' : '3'
        var desc = this.checkDesc
        if (this.$appUrlTag === 0) {
          this.$verifyApp(localStorage.user, id, passValue, desc, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$router.go(-1)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$verifyApp1(this.mechanismId,localStorage.user, id, passValue, desc, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$router.go(-1)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        }

      },
      getAppHistory () {
        if (!this.config.data.launcherName) {
          return
        }
        console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, (res) => {
            console.log('reslist', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$getAppHistory1(this.mechanismId, this.config.data.packagename, (res) => {
            console.log('reslist', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }

      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // 
        //this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      init () {
        this.config = this.$getWObj().filestEdit
        console.log('config', this.config)
        // 0新建 1编辑 2新上传
        switch (this.config.type) {
          case 0:
            //this.getTypeList()
            break
          case 1:
            // this.getTypeList()
            this.getDetail()
            break
          case 2:
            //this.getTypeList()
            // console.log(this.config.data.appScreenShot)
            this.form.flag = this.config.data.flag
            this.isTag = true
            this.form.ver = this.config.data.version
            break
          case 3:
            break
        }
        this.getList()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, (res) => {
            console.log('dv', res)
            this.loading = 0
            if (res.data) {
              this.tableData = res.data
              this.total = res.total
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data.applicationid, (res) => {
            console.log('dv', res)
            this.loading = 0
            if (res.data) {
              this.tableData = res.data
              this.total = res.total
            }
          }, () => {
            // error
            this.loading = 0
          })
        }

      },
      bindOperate (row) {
        // console.log('r', row)
        this.bind(row.terminalId, row.terminalNo)
      },
      bind (tId, tNo) {
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', tId, this.config.data.applicationid, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        }

      },
      srchDevice () {
        this.getDevices()
      }
    },
    mounted () {
      
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?4bcea776